// src/components/Loading.jsx
import React from "react";

/**
 * Standardized Loading Component
 * @param {string} message - Loading message (default: "Loading...")
 * @param {string} className - Optional CSS class name
 * @param {object} style - Optional inline styles
 */
export default function Loading({ message = "Loading...", className = "", style = {} }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={message}
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        fontSize: 14,
        color: "#64748B",
        ...style,
      }}
    >
      <span style={{ marginRight: 8 }}>⏳</span>
      <span>{message}</span>
    </div>
  );
}
